import React from 'react';
import RouteHeader from '../common/RouteHeader';

const NotFoundPage = () => {
    return (
        <div style={{ padding: "10px" }}>
            <RouteHeader />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh' }}>Not Found</div>
        </div>
    )
}

export default NotFoundPage;